import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import {
  PLATFORM_URL_SEGMENT,
  type EditInstPageData,
  type EditTgPageData,
  type InstPage,
  type Platform,
  type TgPage,
} from '../types';

import { axios } from '@/libraries/axios';
import { queryClient, type MutationConfig } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export function editPage({
  platform,
  id,
  data,
}: {
  platform: Platform;
  id: string;
  data: EditTgPageData | EditInstPageData;
}): Promise<{ page: TgPage | InstPage }> {
  return axios.patch(`/${PLATFORM_URL_SEGMENT[platform]}/pages`, { pageId: id, data });
}

type UseEditPageOptions<Platform> = {
  platform: Platform;
  config?: MutationConfig<typeof editPage>;
};

const TOAST_ID = 'edit-page';

export const useEditPage = <Platform>({ platform, config = {} }: UseEditPageOptions<Platform>) =>
  useMutation({
    ...config,
    mutationFn: editPage,
    onMutate(...args) {
      toasts.loadingToast.loading(TOAST_ID);
      config.onMutate?.(...args);
    },
    onSuccess(...args) {
      toasts.loadingToast.success(TOAST_ID);
      queryClient.invalidateQueries(['pages', platform]);
      config.onSuccess?.(...args);
    },
    onError(error: AxiosError<{ error: string }>, ...args) {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      config.onError?.(error, ...args);
    },
  });
